// project imports
import { getVisualDepth } from '../visualDepth';

// ==============================|| OVERRIDES - TABLE CELL ||============================== //

export default function TableCell(theme) {
  const vd = getVisualDepth(theme);
  const edgeColor = vd.tableCellBorderColor ?? theme.palette.divider;

  const commonCell = {
    '&:not(:last-of-type)': {
      position: 'relative',
      '&.MuiTableCell-stickyHeader': {
        position: 'sticky'
      },
      '&:after': {
        position: 'absolute',
        content: '""',
        backgroundColor: edgeColor,
        width: 1,
        height: 'calc(100% - 30px)',
        right: 0,
        top: 16
      }
    }
  };

  return {
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: '0.875rem',
          padding: 12,
          borderColor: edgeColor,
          '&.cell-right': {
            justifyContent: 'flex-end',
            textAlign: 'right',
            '& > *': {
              justifyContent: 'flex-end',
              margin: '0 0 0 auto'
            },
            '& .MuiOutlinedInput-input': {
              textAlign: 'right'
            }
          },
          '&.cell-center': {
            justifyContent: 'center',
            textAlign: 'center',
            '& > *': {
              justifyContent: 'center',
              margin: '0 auto'
            }
          }
        },
        sizeSmall: {
          padding: 8
        },
        head: {
          fontSize: '0.75rem',
          fontWeight: 700,
          textTransform: 'uppercase',
          ...commonCell
        },
        footer: {
          fontSize: '0.75rem',
          textTransform: 'uppercase',
          ...commonCell
        }
      }
    }
  };
}
